(() => {
  const langKey = 'leyl-site-language';
  const returnKey = 'leyl-language-return';
  const languages = { en: 'English', tr: 'Türkçe', sv: 'Svenska', da: 'Dansk', fi: 'Suomi', no: 'Norsk' };
  let active = 'en';
  try {
    const saved = localStorage.getItem(langKey);
    if (saved && languages[saved]) active = saved;
  } catch (_) {}

  document.documentElement.lang = active;
  const updateHeader = () => document.querySelectorAll('.site-language__link').forEach((link) => {
    link.textContent = active.toUpperCase();
    link.setAttribute('aria-label', `Choose language. Current language: ${languages[active]}`);
  });
  const updateOptions = () => document.querySelectorAll('[data-language]').forEach((option) => {
    option.setAttribute('aria-current', option.dataset.language === active ? 'true' : 'false');
  });
  updateHeader();
  updateOptions();

  document.querySelectorAll('.site-language__link').forEach((link) => link.addEventListener('click', () => {
    if (location.pathname.replace(/\/$/, '') !== '/pages/language') {
      try { sessionStorage.setItem(returnKey, location.pathname + location.search + location.hash); } catch (_) {}
    }
  }));

  document.querySelectorAll('[data-language]').forEach((option) => option.addEventListener('click', () => {
    const language = option.dataset.language;
    if (!languages[language]) return;
    active = language;
    try { localStorage.setItem(langKey, active); } catch (_) {}
    document.documentElement.lang = active;
    updateHeader();
    updateOptions();
    document.dispatchEvent(new CustomEvent('leyl:language-change', { detail: { language: active } }));
    let returnTo = '/';
    try {
      const saved = sessionStorage.getItem(returnKey);
      if (saved && saved.startsWith('/') && !saved.startsWith('//')) returnTo = saved;
      sessionStorage.removeItem(returnKey);
    } catch (_) {}
    location.assign(returnTo);
  }));
})();

document.querySelectorAll('.reference-header-banner video').forEach((video) => { video.muted = true; video.play().catch(() => {}); });
